import type { Maybe } from './util'

export enum BreakoutType {
  UNDO = 'undo',
  BY_SIZE = 'by_size',
  BY_POLL = 'by_poll',
  BY_LAST_POLL = 'by_last_poll',
  BY_NUMBER_OF_TEAMS = 'by_number_of_teams',
}

export type UndoBreakoutSettings = { type: BreakoutType.UNDO }

export type BySizeBreakoutSettings = {
  type: BreakoutType.BY_SIZE
  size: number
  single?: Maybe<boolean>
  name?: Maybe<string>
}

export type ByPollBreakoutSettings = {
  type: BreakoutType.BY_POLL
}

export type ByLastPollBreakoutSettings = {
  type: BreakoutType.BY_LAST_POLL
  name?: Maybe<string>
}

export type ByNumberOfTeamsBreakoutSettings = {
  type: BreakoutType.BY_NUMBER_OF_TEAMS
  teams: number
  name?: Maybe<string>
}

export type BreakoutSettings =
  | UndoBreakoutSettings
  | BySizeBreakoutSettings
  | ByPollBreakoutSettings
  | ByLastPollBreakoutSettings
  | ByNumberOfTeamsBreakoutSettings

export type ActivityGroupActivitySettings = {
  breakout?: Maybe<BreakoutSettings>
}
